// extracted by mini-css-extract-plugin
export var clauseRow = "_gx-6";
export var emptyState = "_gx-d";
export var filterContent = "_gx-a";
export var filterGroup = "_gx-1";
export var filterGroupContainer = "_gx-0";
export var nestedGroup = "_gx-2";
export var nestedGroupContent = "_gx-b";
export var nestedGroupDepth1 = "_gx-3";
export var nestedGroupDepth2 = "_gx-4";
export var nestedGroupDepth3 = "_gx-5";
export var nestedGroupEmpty = "_gx-c";
export var operatorAnd = "_gx-8";
export var operatorOr = "_gx-9";
export var operatorToggle = "_gx-7";
export var removeGroupButton = "_gx-e";